export const environment = {
  production: true,
  clientId: "ayCarClient",
  clientSecret: "ayCarSecret",
  tokenScope: "ayCarApp",
  wepAppName: "ayCarWeb",
  refreshTokenScope: "offline_access",
  portalWebApiUrl: "https://apsystem.atumplus.pl/ayCarWebApi/api/",
  userWebApiUrl: "https://apsystem.atumplus.pl/ayCarIdentityServerWebApi/api/",
  tokenApiUrl: "https://apsystem.atumplus.pl/ayCarIdentityServerWebApi/connect/token",
  issuesPortalUrl: "https://github.com/ayCarOrganisation/ayCar/issues/new",
  globalEncKey : "4FIKBLt6WlQTYDw0f",
  allowLocalizationChange: true,
  brand: "ap",
  enableFrontendImageCompression: true,
  imageCompressionMaxWidth: 1365,
  imageCompressionMaxHeight: 1024,
  isTrainingEnv: false,
  };

//training
// export const environment = {
//   production: true,
//   clientId: "ayCarClient",
//   clientSecret: "ayCarSecret",
//   tokenScope: "ayCarApp",
//   wepAppName: "ayCarWeb",
//   refreshTokenScope: "offline_access",
//   portalWebApiUrl: "https://training-apsystem.atumplus.pl/ayCarWebApi/api/",
//   userWebApiUrl: "https://training-apsystem.atumplus.pl/ayCarIdentityServerWebApi/api/",
//   tokenApiUrl: "https://training-apsystem.atumplus.pl/ayCarIdentityServerWebApi/connect/token",
//   issuesPortalUrl: "https://github.com/ayCarOrganisation/ayCar/issues/new",
//   globalEncKey : "4FIKBLt6WlQTYDw0f",
//   allowLocalizationChange: true,
//   brand: "ap",
//  enableFrontendImageCompression: true,
//  imageCompressionMaxWidth: 1365,
//  imageCompressionMaxHeight: 1024,
//   isTrainingEnv: true,
// };

//egSystem
 //export const environment = {
 //  production: true,
 //  clientId: "ayCarClient",
 //  clientSecret: "ayCarSecret",
 //  tokenScope: "ayCarApp",
 //  wepAppName: "ayCarWeb",
 //  refreshTokenScope: "offline_access",
 //    portalWebApiUrl: "https://egsystem.atumplus.pl/ayCarWebApi/api/",
 //    userWebApiUrl: "https://egsystem.atumplus.pl/ayCarIdentityServerWebApi/api/",
 //    tokenApiUrl: "https://egsystem.atumplus.pl/ayCarIdentityServerWebApi/connect/token",
 //    issuesPortalUrl: "https://github.com/ayCarOrganisation/ayCar/issues/new",
 //    globalEncKey : "4FIKBLt6WlQTYDw0f",
 //    allowLocalizationChange: true,
 //    brand: "eg",
 //  enableFrontendImageCompression: true,
//  imageCompressionMaxWidth: 1365,
//  imageCompressionMaxHeight: 1024,
 //    infoDisplayNameKey:"global.emptyEnvInfoName",
 //    isTrainingEnv: "false",
 //};

